import { render } from "./licenceManagementDetail.vue?vue&type=template&id=36f9f62e&scoped=true&ts=true"
import script from "./licenceManagementDetail.vue?vue&type=script&lang=ts"
export * from "./licenceManagementDetail.vue?vue&type=script&lang=ts"

import "./licenceManagementDetail.vue?vue&type=style&index=0&id=36f9f62e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36f9f62e"]])

export default __exports__